(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["byob-fab"] && !Shopify.designMode) return;
  try {
    (function () {
    var fab = document.getElementById('byob-fab');
    if (!fab) return;

    var byobVisible = false;
    var scrolledEnough = false;

    function update() {
      var show = scrolledEnough && !byobVisible;
      fab.classList.toggle('byob-fab--hidden', !show);
    }

    function onScroll() {
      scrolledEnough = window.scrollY > window.innerHeight * 0.8;
      update();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var byob = document.getElementById('byob');
    if (byob && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        byobVisible = entries[0].isIntersecting;
        update();
      }).observe(byob);
    }

    fab.addEventListener('click', function (event) {
      var href = fab.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var target = document.getElementById('byob');
      if (!target) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || typeof target.scrollIntoView !== 'function') return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#byob');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
